export enum CycleTypeEnums {
  DAYS = 0,
  WEEKLY = 1,
  BI_WEEKLY = 2,
}
